import { map } from "rxjs/operators";
import { TransactionType } from "../../../contract/pam.js";
import "@opentelemetry/api";
import "../../../otel/TraceProvider.js";
import "react";
import "react-error-boundary";
import { mergeMap } from "../../../otel/rxjs.js";
import "@opentelemetry/context-zone";
import "@opentelemetry/exporter-trace-otlp-http";
import "@opentelemetry/instrumentation";
import "@opentelemetry/instrumentation-document-load";
import "@opentelemetry/instrumentation-xml-http-request";
import "@opentelemetry/resources";
import "@opentelemetry/sdk-trace-web";
import "@opentelemetry/semantic-conventions";
import "typesafe-actions";
import "rxjs";
import "redux-observable";
import "../../../api/types.js";
import "immer";
import "moment-timezone";
import "react-intl";
import "@apollo/client/errors";
import "@apollo/client";
import "graphql";
import "@apollo/client/link/subscriptions";
import "@apollo/client/utilities";
import "cross-fetch";
import "graphql-ws";
import "../../../node_modules/moment/dist/moment.js";
import "rxjs/ajax";
import "../../../redux-folder/async-action/action.js";
import "../../../redux-folder/error-handling/action.js";
import "../../../redux-folder/actions.js";
import "fast-deep-equal/es6";
import "redux";
import "../../../redux-folder/entity/epics.js";
import "normalizr";
import "../../../redux-folder/entity/EntityProvider.js";
import "../../../redux-folder/realtime/RealtimeNotification.js";
import "reselect";
import "react-redux";
import "react-router";
import { mapViewFilterToString } from "../../../redux-folder/view/utils.js";
import { ValidationCode } from "../types.js";
class ValidationP2PTransferStrategy {
  _userProfileService;
  _userProfileEntityType;
  constructor(userProfileService, userProfileEntityType) {
    this._userProfileService = userProfileService;
    this._userProfileEntityType = userProfileEntityType;
  }
  process({ transactions, agentUid }) {
    const agentFilter = {
      uid: agentUid,
      size: 1,
      page: 1
    };
    const agentFetchPayload = {
      type: this._userProfileEntityType,
      // Commented duy to revert of WPT-7977 ticket
      // fields: ['uid', 'finance.balance', 'channel'],
      fields: ["uid", "finance.balance"],
      filter: mapViewFilterToString(agentFilter, ["uid", "size", "page"])
    };
    return this._userProfileService.get(agentFetchPayload).pipe(
      map((r) => r.responsePayload?.items?.[0]),
      mergeMap((agent) => {
        const downlineRefereesFilter = {
          uid: transactions.map((t) => t.uid).join(" "),
          referrerPlayerId: agentUid,
          isDownstream: true,
          size: transactions.length,
          page: 1
        };
        const downlineRefereesFetchPayload = {
          type: this._userProfileEntityType,
          // Commented duy to revert of WPT-7977 ticket
          // fields: ['uid', 'channel'],
          fields: ["uid"],
          filter: mapViewFilterToString(downlineRefereesFilter, [
            "uid",
            "referrerPlayerId",
            "isDownstream",
            "size",
            "page"
          ])
        };
        return this._userProfileService.get(downlineRefereesFetchPayload).pipe(
          map((r) => r.responsePayload?.items),
          map((downlineReferees) => {
            const balance = agent?.finance?.balance;
            const isAgentBalanceEnough = this.validateAgentBalanceIsEnough(transactions, balance);
            const validationResults = transactions.map((item, index) => {
              const codes = [
                // Commented duy to revert of WPT-7977 ticket
                // agentValidation,
                // this.validatePlayerP2PChannel(item, downlineReferees),
                this.validateNoDuplicates(item, transactions),
                this.validateDownlinePlayersOnly(item, downlineReferees),
                this.validateDataIsValid(item),
                this.validateAmountIsPositive(item),
                this.validateTypeIsValid(item),
                item?.transaction_type === TransactionType.P2PTransferCredit ? isAgentBalanceEnough : this.validatePlayerBalanceIsEnough(item)
              ].filter((c) => c);
              return { id: index, item, errors: codes };
            });
            return validationResults;
          })
        );
      })
    );
  }
  validateAmountIsPositive(item) {
    return item.amount !== null && Number(item?.amount) <= 0 ? { errorCode: ValidationCode.AmountNotPositive } : null;
  }
  validateTypeIsValid(item) {
    const bulkP2PTransferTypes = [TransactionType.P2PTransferCredit, TransactionType.P2PTransferDebit];
    return !bulkP2PTransferTypes.includes(item?.transaction_type) ? { errorCode: ValidationCode.TypeInvalid } : null;
  }
  validateAgentBalanceIsEnough(items, agentBalance) {
    const totalCredit = items.reduce((prev, curr) => {
      prev += (curr.transaction_type === TransactionType.P2PTransferCredit ? curr.amount : 0) ?? 0;
      return prev;
    }, 0);
    return !agentBalance || agentBalance < totalCredit ? { errorCode: ValidationCode.BalanceIsNotEnough } : null;
  }
  validatePlayerBalanceIsEnough(item) {
    return !item.finance?.balance || item.finance?.balance < item.amount ? { errorCode: ValidationCode.BalanceIsNotEnough } : null;
  }
  validateNoDuplicates(currentItem, items) {
    return items.filter((item) => item.uid === currentItem.uid).length > 1 ? { errorCode: ValidationCode.DuplicatesNotAllowed } : null;
  }
  validateDataIsValid(item) {
    return !item.uid || !item.amount || isNaN(Number(item.amount)) ? { errorCode: ValidationCode.UploadedDataIsInvalid } : null;
  }
  validateDownlinePlayersOnly(item, downlineReferees) {
    return !downlineReferees.some((referee) => referee.uid === item.uid) ? { errorCode: ValidationCode.DownlinePlayersOnlyAllowed } : null;
  }
  // Commented duy to revert of WPT-7977 ticket
  // private validateAgentP2PChannel(userProfile: UserProfile): ValidationResultError {
  //     return userProfile?.channel !== Channel.P2P ? {errorCode: ValidationCode.AgentNotInP2PChannel, data: userProfile?.uid} : null;
  // }
  // private validatePlayerP2PChannel(item: P2PTransferModel, userProfiles: UserProfile[]): ValidationResultError {
  //     const player = userProfiles?.find(user => user?.uid === item?.uid);
  //     return player?.channel !== Channel.P2P ? {errorCode: ValidationCode.PlayerNotInP2PChannel, data: player?.uid} : null;
  // }
}
export {
  ValidationP2PTransferStrategy
};
//# sourceMappingURL=validationStrategy.js.map
